import React from 'react';
import { Box, Typography, Switch, CircularProgress, Tooltip } from '@mui/material';
import { colors } from '@src/styles';

export interface CanonicalToggleSwitchProps {
  isEnabled: boolean;
  isToggling: boolean;
  canToggle: boolean;
  onToggle: (newValue: boolean) => void;
}

const CanonicalToggleSwitch: React.FC<CanonicalToggleSwitchProps> = ({
  isEnabled,
  isToggling,
  canToggle,
  onToggle,
}) => {
  const isLocked = isToggling || !canToggle;
  const tone = isEnabled ? colors.status.concluded : colors.brand.textMuted;

  return (
    <Tooltip title={isEnabled ? 'Desativar canônica nesta organização' : 'Ativar canônica nesta organização'} arrow>
      <Box
        component="label"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          flexShrink: 0,
          height: 36,
          paddingLeft: 1.5,
          paddingRight: 0.5,
          borderRadius: '999px',
          border: `1px solid ${isEnabled ? `${colors.status.concluded}66` : colors.brand.line}`,
          backgroundColor: isEnabled ? `${colors.status.concluded}12` : colors.brand.surface,
          cursor: isLocked ? 'default' : 'pointer',
          opacity: isLocked && !isToggling ? 0.6 : 1,
          transition: 'border-color 0.15s ease, background-color 0.15s ease',
          '&:hover': {
            borderColor: isLocked ? undefined : isEnabled ? colors.status.concluded : colors.brand.textMuted,
          },
        }}
      >
        {isToggling ? (
          <CircularProgress size={10} thickness={6} sx={{ color: colors.primary.yellow }} />
        ) : (
          <Box aria-hidden sx={{ width: 8, height: 8, borderRadius: '999px', backgroundColor: tone }} />
        )}
        <Typography
          sx={{
            fontFamily: "'Inter Tight', 'Inter', sans-serif",
            fontSize: '13px',
            fontWeight: 600,
            color: isEnabled ? colors.status.concluded : colors.brand.textSecondary,
            minWidth: 52,
          }}
        >
          {isToggling ? 'Salvando…' : isEnabled ? 'Ativa' : 'Inativa'}
        </Typography>
        <Switch
          size="small"
          checked={isEnabled}
          onChange={(event) => onToggle(event.target.checked)}
          disabled={isLocked}
          inputProps={{ 'aria-label': isEnabled ? 'Desativar canônica' : 'Ativar canônica' }}
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': { color: colors.status.concluded },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: colors.status.concluded,
              opacity: 0.45,
            },
            '& .MuiSwitch-track': { backgroundColor: colors.brand.textMuted },
          }}
        />
      </Box>
    </Tooltip>
  );
};

export default CanonicalToggleSwitch;
